import formTypes from "./formTypes";

const initailState = {
  notify_no : "",
  claim_id : "",
  lisence_info : {
    front : "",
    no : "",
    province : "",
    is_red_plate : "",
    driver_name : "",
    sufferer_type : ""
  },
  contact_info : {
    name : "",
    contact_type : "1",
    contact_title_code : "",
    garage_code : "",
    garage_name : "",
    no_garage_in_system : false,
    is_attorney : false,
    is_company : false,
    tel : "",
    email : "",
    line_id : "",
    labor_cost : 0.00,
    auto_parts : 0.00,
    loss_of_benefit : 0.00,
    tow_car : 0.00
  },
  contact_info_temporary : {
    name : "",
    contact_type : "",
    contact_title_code : "",
    garage_code : "",
    garage_name : "",
    no_garage_in_system : false,
    is_attorney : false,
    is_company : false,
    tel : "",
    email : "",
    line_id : "",
    labor_cost : 0.00,
    auto_parts : 0.00,
    loss_of_benefit : 0.00,
    tow_car : 0.00
  },
  claim_info : {
    type : "1",
    docs : {
      code_1 : {
          name : "ใบเคลม",
          description : "หรือ ต้นฉบับหลักฐานรับผิดชอบความเสียหายรถประกัน",
          items : []
      },
        code_2 : {
          name : "ใบเสนอราคา",
          description : "หรือคุณสามารถใช้ใบเสร็จแทนได้",
          items : []
      },

        code_3 : {
          name : "รูปภาพความเสียหาย",
          description : "กรุณาแสดงภาพความเสียหายรวมถึงส่วนที่เกี่ยวข้อง",
          items : []
        
      },
      
        code_4 : {
          name : "สำเนาบัตรประชาชนคู่กรณี",
          description : "",
          items : []
        
      },
      
        code_5 : {
          name : "สำเนาบัตรประชาชนผู้เอาประกันภัย",
          description : "",
          items : []
        
      },
      
        code_6 : {
          name : "หนังสือมอบอำนาจ",
          description : "พร้อมสำเนาบัตรประชาชนและติดอากรสแตมป์ 30 บาท",
          items : []
        
      },
      
        code_7 : {
          name : "สำเนาบัตรประชาชนผู้มอบอำนาจ",
          description : "",
          items : []
        
      },
      
        code_8 : {
          name : "สำเนาหนังสือรับรองการจดทะเบียน",
          description : "พร้อมสำเนาบัตรประชาชนกรรมการ",
          items : []
        
      },
      
        code_9 : {
          name : "ต้นฉบับคู่มือจดทะเบียนรถ",
          description : "หรือสำเนา และรายการจดทะเบียนเปลี่ยนแปลง และรายการต่อภาษีปีปัจจุบัน",
          items : []
        
      },
      
        code_10 : {
          name : "สำเนากรมธรรม์ พรบ.",
          description : "",
          items : []
        
      },
      
        code_11 : {
          name : "สำเนากรมธรรม์ประกันภัย ภาคสมัครใจ",
          description : "",
          items : []
        
      },
      
      code_12 : {
        name : "ต้นฉบับใบเสร็จรับเงิน",
        description : "หรือ บิลเงินสดค่ารถยก",
        items : []
      
      },
      
      code_13 : {
        name : "ภาพถ่ายขณะยกรถ",
        description : "กรุณาแสดงภาพขณะยกรถ รวมถึงส่วนที่เกี่ยวข้อง",
        items : []
      
      },
      
      code_14 : {
        name : "เอกสารเรียกร้องค่าขาดประโยชน์",
        description : "",
        items : []
      
      },
      code_15 : {
        name : "ใบเคลม",
        description : "หรือ สำเนาหลักฐานรับผิดชอบความเสียหายรถคู่กรณี",
        items : []
      },
      code_16 : {
        name : "ใบเคลม",
        description : "หรือ ต้นฉบับหลักฐานรับผิดชอบความเสียหายรถคู่กรณี",
        items : []
      },
      code_17 : {
        name : "ใบเสนอราคา",
        description : "",
        items : []
      },
      code_18 : {
        name : "ต้นฉบับใบเสร็จค่ารถยก",
        description : "หรือ บิลเงินสดค่ารถยก",
        items : []
      },
      code_19 : {
        name : "ใบเสนอราคา",
        description : "ต้นฉบับใบเสร็จค่ารถยก หรือ บิลเงินสดค่ารถยก​",
        items : []
      },
      code_20 : {
        name : "ภาพถ่ายความเสียหาย",
        description : "กรุณาแสดงภาพความเสียหายรวมถึงส่วนที่เกี่ยวข้อง",
        items : []
      },
      code_21 : {
        name : "ใบเคลม",
        description : "หรือ สำเนาหลักฐานรับผิดชอบความเสียหายรถประกัน",
        items : []
      },
    }
  }
} 


function formReducers( state = initailState, action ){
  switch(action.type) {
    case formTypes.GET_NOTIFY :
      return state.notify_no 
    case formTypes.CLEAR_NOTIFY :
        return {
          ...state,
          notify_no : ""
        }
    case formTypes.UPDATE_NOTIFY :
        return {
          ...state,
          notify_no : action.payload.notify_no
        }    
    case formTypes.UPDATE_CLAIMID :
            return {
              ...state,
              claim_id : action.payload.claim_id
            }  
    case formTypes.UPDATE_LICENSE :
          return {
            ...state,
            lisence_info : action.payload
    }             
    case formTypes.UPDATE_CONTACT :
          return {
            ...state,
            contact_info : action.payload
    }             
    case formTypes.UPDATE_CONTACT_TEMPORARY :
          return {
            ...state,
            contact_info_temporary : action.payload
    }             
    case formTypes.UPDATE_REQUEST_DOCUMENTS :
          return {
            ...state,
            request_documents : action.payload
    }             
    case formTypes.GET_DOC_TYPE_1 :
          return (state.claim_info).docs.code_1
    case formTypes.UPDATE_DOC_TYPE_1 :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_1 : {
              ...state.claim_info.docs.code_1,
              items : [...state.claim_info.docs.code_1.items, action.payload]
            }
          }
        }
    }  
    case formTypes.UPDATE_DOC_TYPE_2 :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_2 : {
              ...state.claim_info.docs.code_2,
              items : [...state.claim_info.docs.code_2.items, action.payload]
            }
          }
        }
    }  
    case formTypes.UPDATE_DOC_TYPE_3 :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_3 : {
              ...state.claim_info.docs.code_3,
              items : [...state.claim_info.docs.code_3.items, action.payload]
            }
          }
        }
    }  
    case formTypes.UPDATE_DOC_TYPE_4 :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_4 : {
              ...state.claim_info.docs.code_4,
              items : [...state.claim_info.docs.code_4.items, action.payload]
            }
          }
        }
    }  
    case formTypes.UPDATE_DOC_TYPE_5 :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_5 : {
              ...state.claim_info.docs.code_5,
              items : [...state.claim_info.docs.code_5.items, action.payload]
            }
          }
        }
    }  
    case formTypes.UPDATE_DOC_TYPE_6 :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_6 : {
              ...state.claim_info.docs.code_6,
              items : [...state.claim_info.docs.code_6.items, action.payload]
            }
          }
        }
    }  
    case formTypes.UPDATE_DOC_TYPE_7 :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_7 : {
              ...state.claim_info.docs.code_7,
              items : [...state.claim_info.docs.code_7.items, action.payload]
            }
          }
        }
    }  
    case formTypes.UPDATE_DOC_TYPE_8 :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_8 : {
              ...state.claim_info.docs.code_8,
              items : [...state.claim_info.docs.code_8.items, action.payload]
            }
          }
        }
    }  
    case formTypes.UPDATE_DOC_TYPE_9 :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_9 : {
              ...state.claim_info.docs.code_9,
              items : [...state.claim_info.docs.code_9.items, action.payload]
            }
          }
        }
    }  
    case formTypes.UPDATE_DOC_TYPE_10 :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_10 : {
              ...state.claim_info.docs.code_10,
              items : [...state.claim_info.docs.code_10.items, action.payload]
            }
          }
        }
    }  
    case formTypes.UPDATE_DOC_TYPE_11 :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_11 : {
              ...state.claim_info.docs.code_11,
              items : [...state.claim_info.docs.code_11.items, action.payload]
            }
          }
        }
    }   
    case formTypes.UPDATE_DOC_TYPE_12 :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_12 : {
              ...state.claim_info.docs.code_12,
              items : [...state.claim_info.docs.code_12.items, action.payload]
            }
          }
        }
    }    
    case formTypes.UPDATE_DOC_TYPE_13 :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_13 : {
              ...state.claim_info.docs.code_13,
              items : [...state.claim_info.docs.code_13.items, action.payload]
            }
          }
        }
    }    
    case formTypes.UPDATE_DOC_TYPE_14 :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_14 : {
              ...state.claim_info.docs.code_14,
              items : [...state.claim_info.docs.code_14.items, action.payload]
            }
          }
        }
    }  
    case formTypes.UPDATE_DOC_TYPE_15 :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_15 : {
              ...state.claim_info.docs.code_15,
              items : [...state.claim_info.docs.code_15.items, action.payload]
            }
          }
        }
    }  
    case formTypes.UPDATE_DOC_TYPE_16 :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_16 : {
              ...state.claim_info.docs.code_16,
              items : [...state.claim_info.docs.code_16.items, action.payload]
            }
          }
        }
    }  
    case formTypes.UPDATE_DOC_TYPE_17 :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_17 : {
              ...state.claim_info.docs.code_17,
              items : [...state.claim_info.docs.code_17.items, action.payload]
            }
          }
        }
    }  
    case formTypes.UPDATE_DOC_TYPE_18 :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_18 : {
              ...state.claim_info.docs.code_18,
              items : [...state.claim_info.docs.code_18.items, action.payload]
            }
          }
        }
    }  
    case formTypes.UPDATE_DOC_TYPE_19 :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_19 : {
              ...state.claim_info.docs.code_19,
              items : [...state.claim_info.docs.code_19.items, action.payload]
            }
          }
        }
    }  
    case formTypes.UPDATE_DOC_TYPE_20 :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_20 : {
              ...state.claim_info.docs.code_20,
              items : [...state.claim_info.docs.code_20.items, action.payload]
            }
          }
        }
    }  
    case formTypes.UPDATE_DOC_TYPE_21 :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_21 : {
              ...state.claim_info.docs.code_21,
              items : [...state.claim_info.docs.code_21.items, action.payload]
            }
          }
        }
    }  
    case formTypes.DELETE_DOC_TYPE_1 :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_1 : {
              ...state.claim_info.docs.code_1,
              items : [
                ...state.claim_info.docs.code_1.items.slice(0, action.payload.index), 
                ...state.claim_info.docs.code_1.items.slice((action.payload.index) + 1)
              ]
            }
          }
        }
    }  
    case formTypes.DELETE_DOC_TYPE_2 :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_2 : {
              ...state.claim_info.docs.code_2,
              items : [
                ...state.claim_info.docs.code_2.items.slice(0, action.payload.index), 
                ...state.claim_info.docs.code_2.items.slice((action.payload.index) + 1)
              ]
            }
          }
        }
    } 
    case formTypes.DELETE_DOC_TYPE_3 :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_3 : {
              ...state.claim_info.docs.code_3,
              items : [
                ...state.claim_info.docs.code_3.items.slice(0, action.payload.index), 
                ...state.claim_info.docs.code_3.items.slice((action.payload.index) + 1)
              ]
            }
          }
        }
    } 
    case formTypes.DELETE_DOC_TYPE_4 :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_4 : {
              ...state.claim_info.docs.code_4,
              items : [
                ...state.claim_info.docs.code_4.items.slice(0, action.payload.index), 
                ...state.claim_info.docs.code_4.items.slice((action.payload.index) + 1)
              ]
            }
          }
        }
    } 
    case formTypes.DELETE_DOC_TYPE_5 :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_5 : {
              ...state.claim_info.docs.code_5,
              items : [
                ...state.claim_info.docs.code_5.items.slice(0, action.payload.index), 
                ...state.claim_info.docs.code_5.items.slice((action.payload.index) + 1)
              ]
            }
          }
        }
    } 
    case formTypes.DELETE_DOC_TYPE_6 :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_6 : {
              ...state.claim_info.docs.code_6,
              items : [
                ...state.claim_info.docs.code_6.items.slice(0, action.payload.index), 
                ...state.claim_info.docs.code_6.items.slice((action.payload.index) + 1)
              ]
            }
          }
        }
    } 
    case formTypes.DELETE_DOC_TYPE_7 :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_7 : {
              ...state.claim_info.docs.code_7,
              items : [
                ...state.claim_info.docs.code_7.items.slice(0, action.payload.index), 
                ...state.claim_info.docs.code_7.items.slice((action.payload.index) + 1)
              ]
            }
          }
        }
    } 
    case formTypes.DELETE_DOC_TYPE_8 :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_8 : {
              ...state.claim_info.docs.code_8,
              items : [
                ...state.claim_info.docs.code_8.items.slice(0, action.payload.index), 
                ...state.claim_info.docs.code_8.items.slice((action.payload.index) + 1)
              ]
            }
          }
        }
    } 
    case formTypes.DELETE_DOC_TYPE_9 :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_9 : {
              ...state.claim_info.docs.code_9,
              items : [
                ...state.claim_info.docs.code_9.items.slice(0, action.payload.index), 
                ...state.claim_info.docs.code_9.items.slice((action.payload.index) + 1)
              ]
            }
          }
        }
    } 
    case formTypes.DELETE_DOC_TYPE_10 :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_10 : {
              ...state.claim_info.docs.code_10,
              items : [
                ...state.claim_info.docs.code_10.items.slice(0, action.payload.index), 
                ...state.claim_info.docs.code_10.items.slice((action.payload.index) + 1)
              ]
            }
          }
        }
    } 
    case formTypes.DELETE_DOC_TYPE_11 :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_11 : {
              ...state.claim_info.docs.code_11,
              items : [
                ...state.claim_info.docs.code_11.items.slice(0, action.payload.index), 
                ...state.claim_info.docs.code_11.items.slice((action.payload.index) + 1)
              ]
            }
          }
        }
    }    
    case formTypes.DELETE_DOC_TYPE_12 :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_12 : {
              ...state.claim_info.docs.code_12,
              items : [
                ...state.claim_info.docs.code_12.items.slice(0, action.payload.index), 
                ...state.claim_info.docs.code_12.items.slice((action.payload.index) + 1)
              ]
            }
          }
        }
    }       
    case formTypes.DELETE_DOC_TYPE_13 :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_13 : {
              ...state.claim_info.docs.code_13,
              items : [
                ...state.claim_info.docs.code_13.items.slice(0, action.payload.index), 
                ...state.claim_info.docs.code_13.items.slice((action.payload.index) + 1)
              ]
            }
          }
        }
    }     
    case formTypes.DELETE_DOC_TYPE_14 :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_14 : {
              ...state.claim_info.docs.code_14,
              items : [
                ...state.claim_info.docs.code_14.items.slice(0, action.payload.index), 
                ...state.claim_info.docs.code_14.items.slice((action.payload.index) + 1)
              ]
            }
          }
        }
    }      
    case formTypes.DELETE_DOC_TYPE_15 :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_15 : {
              ...state.claim_info.docs.code_15,
              items : [
                ...state.claim_info.docs.code_15.items.slice(0, action.payload.index), 
                ...state.claim_info.docs.code_15.items.slice((action.payload.index) + 1)
              ]
            }
          }
        }
    }     
    case formTypes.DELETE_DOC_TYPE_16 :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_16 : {
              ...state.claim_info.docs.code_16,
              items : [
                ...state.claim_info.docs.code_16.items.slice(0, action.payload.index), 
                ...state.claim_info.docs.code_16.items.slice((action.payload.index) + 1)
              ]
            }
          }
        }
    } 
    case formTypes.DELETE_DOC_TYPE_17 :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_17 : {
              ...state.claim_info.docs.code_17,
              items : [
                ...state.claim_info.docs.code_17.items.slice(0, action.payload.index), 
                ...state.claim_info.docs.code_17.items.slice((action.payload.index) + 1)
              ]
            }
          }
        }
    } 
    case formTypes.DELETE_DOC_TYPE_18 :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_18 : {
              ...state.claim_info.docs.code_18,
              items : [
                ...state.claim_info.docs.code_18.items.slice(0, action.payload.index), 
                ...state.claim_info.docs.code_18.items.slice((action.payload.index) + 1)
              ]
            }
          }
        }
    } 
    case formTypes.DELETE_DOC_TYPE_19 :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_19 : {
              ...state.claim_info.docs.code_19,
              items : [
                ...state.claim_info.docs.code_19.items.slice(0, action.payload.index), 
                ...state.claim_info.docs.code_19.items.slice((action.payload.index) + 1)
              ]
            }
          }
        }
    } 
    case formTypes.DELETE_DOC_TYPE_20 :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_20 : {
              ...state.claim_info.docs.code_20,
              items : [
                ...state.claim_info.docs.code_20.items.slice(0, action.payload.index), 
                ...state.claim_info.docs.code_20.items.slice((action.payload.index) + 1)
              ]
            }
          }
        }
    } 
    case formTypes.DELETE_DOC_TYPE_21 :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_21 : {
              ...state.claim_info.docs.code_21,
              items : [
                ...state.claim_info.docs.code_21.items.slice(0, action.payload.index), 
                ...state.claim_info.docs.code_21.items.slice((action.payload.index) + 1)
              ]
            }
          }
        }
    } 
    case formTypes.DELETE_DOC_TYPE_1_ALL :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_1 : {
              ...state.claim_info.docs.code_1,
              items : []
            }
          }
        }
    }  
    case formTypes.DELETE_DOC_TYPE_2_ALL :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_2 : {
              ...state.claim_info.docs.code_2,
              items : []
            }
          }
        }
    }  
    case formTypes.DELETE_DOC_TYPE_3_ALL :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_3 : {
              ...state.claim_info.docs.code_3,
              items : []
            }
          }
        }
    }  
    case formTypes.DELETE_DOC_TYPE_4_ALL :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_4 : {
              ...state.claim_info.docs.code_4,
              items : []
            }
          }
        }
    } 
    case formTypes.DELETE_DOC_TYPE_5_ALL :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_5 : {
              ...state.claim_info.docs.code_5,
              items : []
            }
          }
        }
    }   
    case formTypes.DELETE_DOC_TYPE_6_ALL :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_6 : {
              ...state.claim_info.docs.code_6,
              items : []
            }
          }
        }
    }  
    case formTypes.DELETE_DOC_TYPE_7_ALL :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_7 : {
              ...state.claim_info.docs.code_7,
              items : []
            }
          }
        }
    }  
    case formTypes.DELETE_DOC_TYPE_8_ALL :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_8 : {
              ...state.claim_info.docs.code_8,
              items : []
            }
          }
        }
    }  
    case formTypes.DELETE_DOC_TYPE_9_ALL :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_9 : {
              ...state.claim_info.docs.code_9,
              items : []
            }
          }
        }
    }  
    case formTypes.DELETE_DOC_TYPE_10_ALL :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_10 : {
              ...state.claim_info.docs.code_10,
              items : []
            }
          }
        }
    }  
    case formTypes.DELETE_DOC_TYPE_11_ALL :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_11 : {
              ...state.claim_info.docs.code_11,
              items : []
            }
          }
        }
    }   
    case formTypes.DELETE_DOC_TYPE_12_ALL :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_12 : {
              ...state.claim_info.docs.code_12,
              items : []
            }
          }
        }
    }    
    case formTypes.DELETE_DOC_TYPE_13_ALL :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_13 : {
              ...state.claim_info.docs.code_13,
              items : []
            }
          }
        }
    }    
    case formTypes.DELETE_DOC_TYPE_14_ALL :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_14 : {
              ...state.claim_info.docs.code_14,
              items : []
            }
          }
        }
    }     
    case formTypes.DELETE_DOC_TYPE_15_ALL :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_15 : {
              ...state.claim_info.docs.code_15,
              items : []
            }
          }
        }
    }   
    case formTypes.DELETE_DOC_TYPE_16_ALL :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_16 : {
              ...state.claim_info.docs.code_16,
              items : []
            }
          }
        }
    }   
    case formTypes.DELETE_DOC_TYPE_17_ALL :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_17 : {
              ...state.claim_info.docs.code_17,
              items : []
            }
          }
        }
    }   
    case formTypes.DELETE_DOC_TYPE_18_ALL :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_18 : {
              ...state.claim_info.docs.code_18,
              items : []
            }
          }
        }
    }   
    case formTypes.DELETE_DOC_TYPE_19_ALL :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_19 : {
              ...state.claim_info.docs.code_19,
              items : []
            }
          }
        }
    }   
    case formTypes.DELETE_DOC_TYPE_20_ALL :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_20 : {
              ...state.claim_info.docs.code_20,
              items : []
            }
          }
        }
    }   
    case formTypes.DELETE_DOC_TYPE_21_ALL :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_21 : {
              ...state.claim_info.docs.code_21,
              items : []
            }
          }
        }
    }   
    case formTypes.DELETE_DOC_TYPE_ALL :
      return {
        ...state,
        claim_info : {
          docs : {
            ...state.claim_info.docs,
            code_1 : { ...state.claim_info.docs.code_1, items : [] },
            code_2 : { ...state.claim_info.docs.code_2, items : [] },
            code_3 : { ...state.claim_info.docs.code_3, items : [] },
            code_4 : { ...state.claim_info.docs.code_4, items : [] },
            code_5 : { ...state.claim_info.docs.code_5, items : [] },
            code_6 : { ...state.claim_info.docs.code_6, items : [] },
            code_7 : { ...state.claim_info.docs.code_7, items : [] },
            code_8 : { ...state.claim_info.docs.code_8, items : [] },
            code_9 : { ...state.claim_info.docs.code_9, items : [] },
            code_10 : { ...state.claim_info.docs.code_10, items : [] },
            code_11 : { ...state.claim_info.docs.code_11, items : [] },
            code_12 : { ...state.claim_info.docs.code_12, items : [] },
            code_13 : { ...state.claim_info.docs.code_13, items : [] },
            code_14 : { ...state.claim_info.docs.code_14, items : [] },
            code_15 : { ...state.claim_info.docs.code_15, items : [] },
            code_16 : { ...state.claim_info.docs.code_16, items : [] },
            code_17 : { ...state.claim_info.docs.code_17, items : [] },
            code_18 : { ...state.claim_info.docs.code_18, items : [] },
            code_19 : { ...state.claim_info.docs.code_19, items : [] },
            code_20 : { ...state.claim_info.docs.code_20, items : [] },
            code_21 : { ...state.claim_info.docs.code_21, items : [] },
          }
        }
    }  
    case formTypes.UPDATE_CLAIM_TYPE :
          return {
            ...state,
            claim_info : {
              ...state.claim_info,
              type : action.payload.type
            }
    }    
    default : 
      return state
  }
}

export default formReducers;